import { render, staticRenderFns } from "./modify-data-audit.vue?vue&type=template&id=461ebde2&scoped=true&"
import script from "./modify-data-audit.vue?vue&type=script&lang=js&"
export * from "./modify-data-audit.vue?vue&type=script&lang=js&"
import style0 from "./modify-data-audit.vue?vue&type=style&index=0&id=461ebde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ebde2",
  null
  
)

export default component.exports